var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5, _rect5, _path6, _rect6, _path7, _rect7, _path8, _rect8, _path9, _rect9, _path10, _rect10, _path11, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path12, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _path13, _rect45, _path14, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _path15, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _path16, _rect80, _path17, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _path18, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _path19, _rect115, _path20, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _path21, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _path22, _rect150, _path23, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _path24, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _path25, _rect185, _path26, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _path27, _rect203, _rect204, _rect205, _rect206, _rect207, _path28, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _path29, _rect219, _path30, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _path31, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _path32, _rect254, _path33, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _path34, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _path35, _rect289, _path36, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _path37, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _path38, _rect324, _path39, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _path40, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _path41, _rect359, _path42, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _path43, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _path44, _rect394, _path45, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _path46, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _path47, _rect429, _path48, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _path49, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _path50, _rect464, _path51, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _path52, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _path53, _rect499, _path54, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _path55, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _path56, _rect534, _path57, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _path58, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _path59, _rect569, _path60, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _path61, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _path62, _rect604, _path63, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _path64, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _path65, _rect639, _path66, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _path67, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _path68, _rect674, _path69, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _path70, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _path71, _rect709, _path72, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _path73, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _path74, _rect744, _path75, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _path76, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _path77, _rect779, _path78, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _path79, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _path80, _rect814, _path81, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBricks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2160,
    height: 3840,
    viewBox: "0 0 2160 3840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12.5 -61H27.5V-47H49.5V-61H89.5V-47H111.5V-61H151.5V-47H173.5V-61H213.5V-47H221.5V33H-22.5V-47H-12.5V-61Z",
    fill: "#00963E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: -47,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.5 -61H272.5V-47H294.5V-61H334.5V-47H356.5V-61H396.5V-47H418.5V-61H458.5V-47H466.5V33H222.5V-47H232.5V-61Z",
    fill: "#00963E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: -47,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.5 -61H517.5V-47H539.5V-61H579.5V-47H601.5V-61H641.5V-47H663.5V-61H703.5V-47H711.5V33H467.5V-47H477.5V-61Z",
    fill: "#00963E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: -47,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M722.5 -61H762.5V-47H784.5V-61H824.5V-47H846.5V-61H886.5V-47H908.5V-61H948.5V-47H956.5V33H712.5V-47H722.5V-61Z",
    fill: "#00963E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: -47,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.5 -61H1007.5V-47H1029.5V-61H1069.5V-47H1091.5V-61H1131.5V-47H1153.5V-61H1193.5V-47H1201.5V33H957.5V-47H967.5V-61Z",
    fill: "#00963E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: -47,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1212.5 -61H1252.5V-47H1274.5V-61H1314.5V-47H1336.5V-61H1376.5V-47H1398.5V-61H1438.5V-47H1446.5V33H1202.5V-47H1212.5V-61Z",
    fill: "#00963E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: -47,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1457.5 -61H1497.5V-47H1519.5V-61H1559.5V-47H1581.5V-61H1621.5V-47H1643.5V-61H1683.5V-47H1691.5V33H1447.5V-47H1457.5V-61Z",
    fill: "#00963E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: -47,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1702.5 -61H1742.5V-47H1764.5V-61H1804.5V-47H1826.5V-61H1866.5V-47H1888.5V-61H1928.5V-47H1936.5V33H1692.5V-47H1702.5V-61Z",
    fill: "#00963E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: -47,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1947.5 -61H1987.5V-47H2009.5V-61H2049.5V-47H2071.5V-61H2111.5V-47H2133.5V-61H2173.5V-47H2181.5V33H1937.5V-47H1947.5V-61Z",
    fill: "#00963E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 33,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 34H99V114H-145V34Z",
    fill: "#00963E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 34,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100 34H344V114H100V34Z",
    fill: "#00963E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 34,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 34,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 34,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 34,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 34,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 34,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 34,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 34,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 34,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 34,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 34,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 34,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 34,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 34,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 34,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 34,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 114,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 115H221.5V195H-22.5V115Z",
    fill: "#00963E"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 115,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 115,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 115,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 115,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 115,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 115,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 115,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 115,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 115,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 115,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 115,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 115,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 115,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 115,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 115,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 115,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 195,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 196H99V276H-145V196Z",
    fill: "#00963E"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 196,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100 196H344V276H100V196Z",
    fill: "#00963E"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 196,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 196,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 196,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 196,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 196,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 196,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 196,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 196,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 196,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 196,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 196,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 196,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 196,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 196,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 196,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 196,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 276,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 277H221.5V357H-22.5V277Z",
    fill: "#00963E"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 277,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 277,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 277,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 277,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 277,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 277,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 277,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 277,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 277,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 277,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 277,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 277,
    width: 244,
    height: 80,
    fill: "#9ACEA3"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 277,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 277,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 277,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 277,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 357,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 358H99V438H-145V358Z",
    fill: "#00963E"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 358,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100 358H344V438H100V358Z",
    fill: "#00963E"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 358,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 358,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 358,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 358,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 358,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 358,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 358,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 358,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 358,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 358,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 358,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 358,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 358,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 358,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 358,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 358,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 438,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 439H221.5V519H-22.5V439Z",
    fill: "#00963E"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 439,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 439,
    width: 244,
    height: 80,
    fill: "#9ACEA3"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 439,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 439,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 439,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 439,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 439,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 439,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 439,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 439,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 439,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 439,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 439,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 439,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 439,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 439,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 519,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 520H99V600H-145V520Z",
    fill: "#00963E"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 520,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100 520H344V600H100V520Z",
    fill: "#00963E"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 520,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 520,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 520,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 520,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 520,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 520,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 520,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 520,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 520,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 520,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 520,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 520,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 520,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 520,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 520,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 520,
    width: 244,
    height: 80,
    fill: "#005321"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 600,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 601H221.5V681H-22.5V601Z",
    fill: "#00963E"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 601,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 601,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 601,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 601,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 601,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 601,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 601,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 601,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 601,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 601,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 601,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 601,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 601,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 601,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 601,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 601,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 681,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 682H99V762H-145V682Z",
    fill: "#00963E"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 682,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M100 682H344V762H100V682Z",
    fill: "#00963E"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 682,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 682,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 682,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 682,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 682,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 682,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 682,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 682,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 682,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 682,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 682,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 682,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 682,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 682,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 682,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 682,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 762,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 763H221.5V843H-22.5V763Z",
    fill: "#00963E"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 763,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 763,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 763,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 763,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 763,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 763,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 763,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 763,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 763,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 763,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 763,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 763,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 763,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 763,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 763,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 763,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 843,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 844H99V924H-145V844Z",
    fill: "#00963E"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 844,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M100 844H344V924H100V844Z",
    fill: "#00963E"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 844,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 844,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 844,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 844,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 844,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 844,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 844,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 844,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 844,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 844,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 844,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 844,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 844,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 844,
    width: 244,
    height: 80,
    fill: "#9ACEA3"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 844,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 844,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 924,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 925H221.5V1005H-22.5V925Z",
    fill: "#00963E"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 925,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 925,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 925,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 925,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 925,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 925H956.5V1005H712.5V925Z",
    fill: "#006A2A"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 925,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 925,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 925,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 925,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 925,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 925,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 925,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 925,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 925,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 925,
    width: 244,
    height: 80,
    fill: "#9ACEA3"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1005,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 1006H99V1086H-145V1006Z",
    fill: "#00963E"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 1006,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M100 1006H344V1086H100V1006Z",
    fill: "#00963E"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 1006,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 1006,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 1006,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 1006,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 1006,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 1006,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1006,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 1006,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 1006,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 1006,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 1006,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 1006,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 1006,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 1006,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 1006,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 1006,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1086,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 1087H221.5V1167H-22.5V1087Z",
    fill: "#00963E"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 1087,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 1087,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 1087,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 1087,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 1087,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 1087,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 1087,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 1087,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 1087,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 1087,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 1087,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 1087,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 1087,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 1087,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 1087,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 1087,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1167,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 1168H99V1248H-145V1168Z",
    fill: "#00963E"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 1168,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M100 1168H344V1248H100V1168Z",
    fill: "#00963E"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 1168,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 1168,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 1168,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 1168,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 1168,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 1168,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1168,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 1168,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 1168,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 1168,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 1168,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 1168,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 1168,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 1168,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 1168,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 1168,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1248,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 1249H221.5V1329H-22.5V1249Z",
    fill: "#00963E"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 1249,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 1249,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 1249,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 1249,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 1249,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 1249,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 1249,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 1249,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 1249,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 1249,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 1249,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 1249,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 1249,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 1249,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 1249,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 1249,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1329,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 1330H99V1410H-145V1330Z",
    fill: "#00963E"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 1330,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M100 1330H344V1410H100V1330Z",
    fill: "#00963E"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 1330,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 1330,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 1330,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 1330,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 1330,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 1330,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1330,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 1330,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 1330,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 1330,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 1330,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 1330,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 1330,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 1330,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 1330,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 1330,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1410,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 1411H221.5V1491H-22.5V1411Z",
    fill: "#00963E"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 1411,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 1411,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 1411,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 1411,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 1411,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 1411,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 1411,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 1411,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 1411,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 1411,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 1411,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 1411,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 1411,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 1411,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 1411,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 1411,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1491,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 1492H99V1572H-145V1492Z",
    fill: "#9ACEA3"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 1492,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M100 1492H344V1572H100V1492Z",
    fill: "#00963E"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 1492,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 1492,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 1492,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 1492,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 1492,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 1492,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1492,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 1492,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 1492,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 1492,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 1492,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 1492,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 1492,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 1492,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 1492,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 1492,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1572,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 1573H221.5V1653H-22.5V1573Z",
    fill: "#00963E"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 1573,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 1573,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 1573,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 1573,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 1573,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 1573,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 1573,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 1573,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 1573,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 1573,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 1573,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 1573,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 1573,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 1573,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 1573,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 1573,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1653,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 1654H99V1734H-145V1654Z",
    fill: "#00963E"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 1654,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M100 1654H344V1734H100V1654Z",
    fill: "#00963E"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 1654,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 1654,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 1654,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 1654,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 1654,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 1654,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1654,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 1654,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 1654,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 1654,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 1654,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 1654,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 1654,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 1654,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 1654,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 1654,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1734,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 1735H221.5V1815H-22.5V1735Z",
    fill: "#00963E"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 1735,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 1735,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 1735,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 1735,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 1735,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 1735,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 1735,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 1735,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 1735,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 1735,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 1735,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 1735,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 1735,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 1735,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 1735,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 1735,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1815,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 1816H99V1896H-145V1816Z",
    fill: "#00963E"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 1816,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M100 1816H344V1896H100V1816Z",
    fill: "#00963E"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 1816,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 1816,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 1816,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 1816,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 1816,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 1816,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1816,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 1816,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 1816,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 1816,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 1816,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 1816,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 1816,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 1816,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 1816,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 1816,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1896,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 1897H221.5V1977H-22.5V1897Z",
    fill: "#00963E"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 1897,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 1897,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 1897,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 1897,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 1897,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 1897,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 1897,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 1897,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 1897,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 1897,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 1897,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 1897,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 1897,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 1897,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 1897,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 1897,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 1977,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 1978H99V2058H-145V1978Z",
    fill: "#00963E"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 1978,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M100 1978H344V2058H100V1978Z",
    fill: "#00963E"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 1978,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 1978,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 1978,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 1978,
    width: 244,
    height: 80,
    fill: "#9ACEA3"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 1978,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 1978,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1978,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 1978,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 1978,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 1978,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 1978,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 1978,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 1978,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 1978,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 1978,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 1978,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2058,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 2059H221.5V2139H-22.5V2059Z",
    fill: "#00963E"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 2059,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 2059,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 2059,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 2059,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 2059,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 2059,
    width: 244,
    height: 80,
    fill: "#9ACEA3"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 2059,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 2059,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 2059,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 2059,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 2059,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 2059,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 2059,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 2059,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 2059,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 2059,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2139,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 2140H99V2220H-145V2140Z",
    fill: "#00963E"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 2140,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M100 2140H344V2220H100V2140Z",
    fill: "#00963E"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 2140,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 2140,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 2140,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 2140,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 2140,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 2140,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 2140,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 2140,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 2140,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 2140,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 2140,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 2140,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 2140,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 2140,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 2140,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 2140,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2220,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 2221H221.5V2301H-22.5V2221Z",
    fill: "#00963E"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 2221,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 2221,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 2221,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 2221,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 2221,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 2221,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 2221,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 2221,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 2221,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 2221,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 2221,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 2221,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 2221,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 2221,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 2221,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 2221,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2301,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 2302H99V2382H-145V2302Z",
    fill: "#00963E"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 2302,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M100 2302H344V2382H100V2302Z",
    fill: "#00963E"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 2302,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 2302,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 2302,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 2302,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 2302,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 2302,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 2302,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 2302,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 2302,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 2302,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 2302,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 2302,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 2302,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 2302,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 2302,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 2302,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2382,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 2383H221.5V2463H-22.5V2383Z",
    fill: "#00963E"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 2383,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 2383,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 2383,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 2383,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 2383,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 2383,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 2383,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 2383,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 2383,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 2383,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 2383,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 2383,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 2383,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 2383,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 2383,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 2383,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2463,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 2464H99V2544H-145V2464Z",
    fill: "#00963E"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 2464,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M100 2464H344V2544H100V2464Z",
    fill: "#00963E"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 2464,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 2464,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 2464,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 2464,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 2464,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 2464,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 2464,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 2464,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 2464,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 2464,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 2464,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 2464,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 2464,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 2464,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 2464,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 2464,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2544,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 2545H221.5V2625H-22.5V2545Z",
    fill: "#00963E"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 2545,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 2545,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 2545,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 2545,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 2545,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 2545,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 2545,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 2545,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 2545,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 2545,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 2545,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 2545,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 2545,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 2545,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 2545,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 2545,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2625,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 2626H99V2706H-145V2626Z",
    fill: "#00963E"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 2626,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M100 2626H344V2706H100V2626Z",
    fill: "#00963E"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 2626,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 2626,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 2626,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 2626,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 2626,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 2626,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 2626,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 2626,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 2626,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 2626,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 2626,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 2626,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 2626,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 2626,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 2626,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 2626,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2706,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 2707H221.5V2787H-22.5V2707Z",
    fill: "#00963E"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 2707,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 2707,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 2707,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 2707,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 2707,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 2707,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 2707,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 2707,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 2707,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 2707,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 2707,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 2707,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 2707,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 2707,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 2707,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 2707,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2787,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 2788H99V2868H-145V2788Z",
    fill: "#00963E"
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 2788,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M100 2788H344V2868H100V2788Z",
    fill: "#00963E"
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 2788,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 2788,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 2788,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 2788,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 2788,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 2788,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 2788,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 2788,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 2788,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 2788,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 2788,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 2788,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 2788,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 2788,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 2788,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 2788,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2868,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 2869H221.5V2949H-22.5V2869Z",
    fill: "#00963E"
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 2869,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 2869,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 2869,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 2869,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 2869,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 2869,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 2869,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 2869,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 2869,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 2869,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 2869,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 2869,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 2869,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 2869,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 2869,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 2869,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 2949,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 2950H99V3030H-145V2950Z",
    fill: "#00963E"
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 2950,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M100 2950H344V3030H100V2950Z",
    fill: "#00963E"
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 2950,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 2950,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 2950,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 2950,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 2950,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 2950,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 2950,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 2950,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 2950,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 2950,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 2950,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 2950,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 2950,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 2950,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 2950,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 2950,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3030,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 3031H221.5V3111H-22.5V3031Z",
    fill: "#00963E"
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 3031,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 3031,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 3031,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 3031,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 3031,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 3031,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 3031,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 3031,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 3031,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 3031,
    width: 244,
    height: 80,
    fill: "#9ACEA3"
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 3031,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 3031,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 3031,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 3031,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 3031,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 3031,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3111,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 3112H99V3192H-145V3112Z",
    fill: "#00963E"
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 3112,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M100 3112H344V3192H100V3112Z",
    fill: "#00963E"
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 3112,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 3112,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 3112,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 3112,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 3112,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 3112,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 3112,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 3112,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 3112,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 3112,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 3112,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 3112,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 3112,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 3112,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 3112,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 3112,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3192,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 3193H221.5V3273H-22.5V3193Z",
    fill: "#00963E"
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 3193,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 3193,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 3193,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 3193,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 3193,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 3193,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 3193,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 3193,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 3193,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 3193,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 3193,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 3193,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 3193,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 3193,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 3193,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 3193,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3273,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 3274H99V3354H-145V3274Z",
    fill: "#00963E"
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 3274,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M100 3274H344V3354H100V3274Z",
    fill: "#00963E"
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 3274,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 3274,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 3274,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 3274,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 3274,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 3274,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 3274,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 3274,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 3274,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 3274,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 3274,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 3274,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 3274,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 3274,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 3274,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 3274,
    width: 244,
    height: 80,
    fill: "#9ACEA3"
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3354,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 3355H221.5V3435H-22.5V3355Z",
    fill: "#00963E"
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 3355,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 3355,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 3355,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 3355,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 3355,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 3355,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 3355,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 3355,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 3355,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 3355,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 3355,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 3355,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 3355,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 3355,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 3355,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 3355,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3435,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 3436H99V3516H-145V3436Z",
    fill: "#00963E"
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 3436,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M100 3436H344V3516H100V3436Z",
    fill: "#00963E"
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 3436,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 3436,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 3436,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 3436,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 3436,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 3436,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 3436,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 3436,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 3436,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 3436,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 3436,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 3436,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 3436,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 3436,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 3436,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 3436,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3516,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 3517H221.5V3597H-22.5V3517Z",
    fill: "#00963E"
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 3517,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 3517,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 3517,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 3517,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 3517,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 3517,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 3517,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 3517,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 3517,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 3517,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 3517,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 3517,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 3517,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 3517,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 3517,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 3517,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3597,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 3598H99V3678H-145V3598Z",
    fill: "#00963E"
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 3598,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M100 3598H344V3678H100V3598Z",
    fill: "#00963E"
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 3598,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 3598,
    width: 244,
    height: 80,
    fill: "#006A2A"
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 3598,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 3598,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 3598,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 3598,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 3598,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 3598,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 3598,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 3598,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 3598,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 3598,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 3598,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 3598,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 3598,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 3598,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3678,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.5 3679H221.5V3759H-22.5V3679Z",
    fill: "#00963E"
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 3679,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 3679,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 3679,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    x: 467.5,
    y: 3679,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    x: 711.5,
    y: 3679,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    x: 712.5,
    y: 3679,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    x: 956.5,
    y: 3679,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    y: 3679,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    x: 1201.5,
    y: 3679,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    x: 1202.5,
    y: 3679,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    x: 1446.5,
    y: 3679,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.5,
    y: 3679,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    x: 1691.5,
    y: 3679,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    x: 1692.5,
    y: 3679,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    x: 1936.5,
    y: 3679,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    x: 1937.5,
    y: 3679,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: 3759,
    width: 2451,
    height: 1,
    fill: "#005321"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M-145 3760H99V3840H-145V3760Z",
    fill: "#00963E"
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 3760,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M100 3760H344V3840H100V3760Z",
    fill: "#00963E"
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 3760,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 3760,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 3760,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 3760,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    x: 834,
    y: 3760,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: 3760,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 3760,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 3760,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 3760,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    x: 1325,
    y: 3760,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    x: 1569,
    y: 3760,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 3760,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    x: 1814,
    y: 3760,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    x: 1815,
    y: 3760,
    width: 244,
    height: 80,
    fill: "#00963E"
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    x: 2059,
    y: 3760,
    width: 1,
    height: 80,
    fill: "#005321"
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    x: 2060,
    y: 3760,
    width: 244,
    height: 80,
    fill: "#00963E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBricks);
export default __webpack_public_path__ + "static/media/bricks.a21843ba60eed76400b86e9e05d43b4f.svg";
export { ForwardRef as ReactComponent };